import React from 'react'
import {
  IconButtonProps,
  IconButton,
  CircularProgress,
  Typography
} from '@mui/material'
import { makeStyles } from '@mui/styles'

import AddCircleIcon from '@mui/icons-material/AddCircle'

interface SaveIconProps extends IconButtonProps {
  companionText?: string
  fontSize: 'small' | 'medium'
  isLoading?: boolean
}

export const AddIconButton: React.FC<SaveIconProps> = ({
  companionText,
  fontSize,
  isLoading = false,
  ...iconButtonProps
}) => {
  const classes = useStyles()

  return (
    <div className={classes.flexContainer}>
      {companionText && (
        <Typography variant='body1'>{companionText}</Typography>
      )}
      <IconButton aria-label='delete' disabled={isLoading} {...iconButtonProps}>
        {isLoading ? (
          <CircularProgress size={fontSize} />
        ) : (
          <AddCircleIcon fontSize={fontSize} />
        )}
      </IconButton>
    </div>
  )
}

const useStyles = makeStyles({
  flexContainer: {
    display: 'flex',
    alignItems: 'center'
  }
})
